import {
  WHATSAPP_CHART_METRICS,
  WHATSAPP_DEFAULT_METRIC_IDS,
  findWhatsappMetric,
} from './whatsappChartMetrics';
import { resolveSeriesColor } from '../utils/chartTheme';

const INTERVENE_CHART_METRICS = [
  { id: 'inbound_count', label: 'Inbound' },
  { id: 'outbound_human_count', label: 'Outbound' },
];

const INTERVENE_DEFAULT_METRIC_IDS = ['inbound_count', 'outbound_human_count'];

const METRIC_PALETTE_INDEX = Object.fromEntries([
  ...WHATSAPP_CHART_METRICS.map((metric, index) => [metric.id, index]),
  ['inbound_count', 0],
  ['outbound_human_count', 1],
]);

const BY_ID = Object.fromEntries(
  [...WHATSAPP_CHART_METRICS, ...INTERVENE_CHART_METRICS].map((metric) => [metric.id, metric])
);

export function decorateChartSeries(series = [], palette = []) {
  return series.map((item, index) => {
    const known = findWhatsappMetric(item.id) || BY_ID[item.id];
    const paletteIndex = METRIC_PALETTE_INDEX[item.id] ?? index;
    const resolvedColor = item.color || known?.color || resolveSeriesColor(palette, paletteIndex);
    return {
      id: item.id || `series-${index}`,
      label: known?.label || item.label || item.id || 'Value',
      color: resolvedColor,
      data: (item.data || []).map((value) => Number(value) || 0),
    };
  });
}

export function defaultVisibleMetricIds(series = []) {
  const ids = series.map((item) => item.id);
  const preferredWhatsapp = ids.filter((id) => WHATSAPP_DEFAULT_METRIC_IDS.includes(id));
  if (preferredWhatsapp.length) return preferredWhatsapp;
  const preferredIntervene = ids.filter((id) => INTERVENE_DEFAULT_METRIC_IDS.includes(id));
  if (preferredIntervene.length) return preferredIntervene;
  return ids;
}
